<template>
  <div style="position: relative; min-height: calc(100vh - 148px)">
    <div class="page_title flex_between">
      <span>{{ page_title }}</span>
      <span>
        <el-button
          type="primary"
          style="width: 100px; margin-right: 10px"
          @click="submit"
          >保存</el-button
        >
        <el-button style="width: 100px" @click="back" type="plain"
          >退出</el-button
        >
      </span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <span class="itemtitle">
            <span style="color: red">*</span>
            书籍名称</span
          >
          <el-input v-model="book_name" style="width: 375px"></el-input>
        </div>
        <div style="margin: 20px 0">
          <span class="itemtitle">作者</span>
          <el-input v-model="author" style="width: 375px"></el-input>
        </div>
        <div>
          <span class="itemtitle"> 书籍分类</span>
          <el-select
            v-model="category_id"
            placeholder="请选择"
            style="width: 375px"
          >
            <el-option
              v-for="item in options"
              :key="item.category_id"
              :label="item.category_name"
              :value="item.category_id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex" style="margin: 20px 0">
          <div class="itemtitle">
            <span style="color: red">*</span> 封面图片
          </div>
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="
                (res, file, fileList) => {
                  return handleAvatarSuccess(res, file, fileList, 1);
                }
              "
              :before-upload="
                (file) => {
                  return beforeAvatarUpload(file, 1);
                }
              "
            >
              <img v-if="pic_url" :src="pic_url" class="avatar" />
              <div v-else>
                <i class="el-icon-circle-plus uploader-icon"></i>
                <div
                  style="color: #8c99a4; font-weight: 600; margin: 16px 0 8px"
                >
                  请上传图片
                </div>
                <div style="width: 130px; color: #a9b4b6; font-size: 12px">
                  支持jpg, png, jpeg格式 最佳尺寸750x410
                </div>
              </div>
              <div class="delimg" @click="delImg(1)" v-if="pic_url">
                <i class="el-icon-delete-solid"></i>
              </div>
            </el-upload>
          </div>
        </div>

        <div>
          <div class="itemtitle" style="width: 145px; margin-bottom: 10px">
            <span> <span style="color: red">*</span> 文件上传 </span>
            <span style="color: #ccc">epub格式</span>
          </div>
          <div style="padding-left: 90px">
            <div>
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :data="uploadExtraData"
                :headers="uploadHeaders"
                :show-file-list="false"
                accept=".epub"
                name="image"
                ref="upload"
                :limit="1"
                :on-success="
                  (res, file, fileList) => {
                    return handleAvatarSuccess(res, file, fileList, 0);
                  }
                "
                :before-upload="
                  (file) => {
                    return beforeAvatarUpload(file, 0);
                  }
                "
              >
                <div v-if="file_url">
                  <i class="el-icon-document"></i>
                  <span style="margin: 0 100px 0 6px">{{ file_name }}</span>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="delImg(0)"
                  ></el-button>
                </div>
                <el-button type="primary" size="medium" v-else
                  >点击上传</el-button
                >
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constant from '../../../service/common/constant';
export default {
  data() {
    return {
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      },
      page_title: this.$route.query.book_id ? '编辑书籍' : '添加书籍',
      options: [],
      category_id: '',
      book_name: '',
      author: '',
      pic: '',
      pic_url: '',
      file_url: '',
      file_name: ''
    };
  },
  computed: {
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  methods: {
    // 获取列表
    getList() {
      this.axios.post('platform/library/getBookCategoryList').then((res) => {
        this.options = res.data.list;
      });
    },
    //上传成功
    handleAvatarSuccess(res, file, fileList, status) {
      if (res.code === 0) {
        if (status) {
          //半路径
          this.pic = res.data.pic;
          //绝对路径
          this.pic_url = res.data.path;
        } else {
          //半路径
          this.file_url = res.data.pic;
          this.$refs.upload.clearFiles();
        }
      } else {
        this.$message.error(res.message);
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file, status) {
      if (status) {
        const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isSupportType) {
          this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
          return false;
        }
        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!');
          return false;
        }
        const suffix = file.name.substring(file.name.lastIndexOf('.'));
        this.uploadExtraData.suffix = suffix;
        this.uploadHeaders.timestamp = Date.now();
        const _this = this;
        return new Promise((resolve) => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = 750;
            const height = (750 / image.width) * image.height;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoFile(dataUrl, file.name);
            resolve(blobData);
          };
          reader.onload = (e) => {
            image.src = e.target.result;
          };
          reader.readAsDataURL(file);
        });
      } else {
        const supportEpubTypes = ['application/epub', 'application/epub+zip'];
        const isEpubType = _.indexOf(supportEpubTypes, file.type) !== -1;
        if (!isEpubType) {
          this.$message.error('上传文件只能是epub格式!');
          return false;
        }
        this.file_name = file.name;
        const suffix = file.name.substring(file.name.lastIndexOf('.'));
        this.uploadExtraData.suffix = suffix;
        this.uploadExtraData.suffix = '.epub';
        this.uploadExtraData.img_type = 6;
        this.uploadHeaders.timestamp = Date.now();
        return isEpubType;
      }
    },
    //删除图片
    delImg(status) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      if (status) {
        this.pic = '';
        this.pic_url = '';
      } else {
        this.file_url = '';
        this.file_name = '';
        this.$forceUpdate();
      }
    },
    //保存/发布
    submit() {
      if (!this.book_name) {
        this.$message.error('请填写书籍名称');
        return false;
      }
      if (!this.pic) {
        this.$message.error('请上传封面图片');
        return false;
      }
      if (!this.file_url) {
        this.$message.error('请上传书籍文件');
        return false;
      }
      let data = {
        book_name: this.book_name,
        category_id: this.category_id,
        author: this.author,
        pic: this.pic,
        file_url: this.file_url,
        file_name: this.file_name
      };
      let url = 'platform/library/saveBookInfo';
      if (this.book_id) {
        data.book_id = this.book_id;
        url = 'platform/library/editBookInfo';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功');
          this.back();
        }
      });
    },
    //获取详情
    getDetail() {
      let book_id = this.book_id;
      this.axios
        .post('platform/library/getBookInfo', { book_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.book_name = info.book_name;
            this.pic = info.pic;
            this.pic_url = info.pic_url;
            this.category_id = info.category_id;
            this.author = info.author;
            this.file_url = info.file_url;
            this.file_name = info.file_name;
          }
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getList();
    if (this.$route.query.book_id) {
      this.book_id = this.$route.query.book_id;
      this.getDetail();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.type {
  font-weight: 600;
}
.itemtitle {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
}
.imgbox {
  width: 375px;
  height: 205px;
  background-color: #eff3f5;
  box-shadow: inset 2px 2px 4px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: dashed 1px #b8c4ce;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;

  .avatar {
    width: 375px;
    height: 205px;
  }
  .uploader-icon {
    font-size: 60px;
    color: #36af71;
  }
  .delimg {
    display: none;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #fff;
    font-size: 20px;
    color: #e74c3d;
  }
  &:hover {
    .delimg {
      display: block;
    }
  }
}
</style>